<template>
  <div>
    <custom-callout
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2"
      :border-color="getStudentBookStatusColor(value.statusId)"
      @click:open="toggleAdditionalInfo()"
    >
      <div class="row mt-2 pb-3">
        <div
          :class="[
            'col-md-3',
            { 'pt-3 pl-q': !isMobile, 'col-8 pt-2': isMobile }
          ]"
        >
          <div class="row h-50">
            <div>
              <custom-balloon
                class="px-3"
                :text="value.status"
                :background-color="getStudentBookStatusColor(value.statusId)"
              />
            </div>
          </div>
          <div class="row mt-1">
            <div class="col">
              <div class="info-text-title">
                {{ value.studentSieId }}
              </div>
              <p class="info-text">
                {{ value.studentName }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-7 pt-3 grey-divider">
          <div :class="['row', { 'pt-2': isMobile }]">
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Título:
              </div>
              <p class="info-text">
                {{ value.title }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Materia:
              </div>
              <p class="info-text">
                {{ value.subject }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Grado:
              </div>
              <p class="info-text">
                {{ value.grade }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                CSEE:
              </div>
              <p class="info-text">
                {{ value.csee }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Municipio:
              </div>
              <p class="info-text">
                {{ value.municipality }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Escuela:
              </div>
              <p class="info-text">{{ value.schoolCode }}-{{ value.school }}</p>
            </div>
          </div>
        </div>

        <div class="col-md-2 pt-3">
          <div class="row w-100 custom-button text-right pr-md-2">
            <dropdown
              :class="['w-100', { 'pl-c': isMobile }]"
              name="Actions"
              :title="'Acciones'"
              :items="getBooksOptions()"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <a
      :ref="`ei-collapse-${uniqueKey}`"
      class="hidden"
      data-toggle="collapse"
      :href="`#ei-collapse-${uniqueKey}`"
      aria-expanded="false"
      :aria-controls="`ei-collapse-${uniqueKey}`"
    />
    <template>
      <div
        :id="`ei-collapse-${uniqueKey}`"
        class="collapse additional-container"
      >
        <div class="p-2 mt-1">
          <div class="bg-gray">
            <div class="bg-white p-3 rounded">
              <DetermineBook
                v-if="isPendingCSEEDetermination"
                v-model="value"
                :collections="collections"
                @success-determine-book="refreshSearch"
                @cancel-determine-book="hideDetermineBook"
              />
              <DetermineBookDate
                v-if="isPendingStudentDeliveryDetermination"
                v-model="value"
                @success-determine-book="refreshSearch"
                @cancel-determine-book="hideDetermineBook"
              />
              <StatusReturnReason
                v-if="isStatusReturnReasonVisible"
                v-model="value"
                @success-return-status="refreshSearch"
                @cancel-return-status="hideStatusReturnReason"
              />
              <CustomTab
                v-if="!isDetermineBookVisible && !isStatusReturnReasonVisible"
                content-class="mt-3"
                :no-nav-style="true"
                nav-class="nav-vue-underline"
              >
                <CustomTabItem class="mt-2" title="Información General">
                  <span>
                    <i class="fa fa-info-circle mr-2 orange" />
                    <span class="title">
                      Información Adicional del Libro
                    </span>
                  </span>
                  <BookInfo :book="value" :is-management-book="true" />
                </CustomTabItem>
                <CustomTabItem class="mt-2" title="Historial">
                  <span>
                    <i class="fa fa-info-circle mr-2 orange" />
                    <span class="title">
                      Historial de Estatus
                    </span>
                  </span>
                  <History :book="value" />
                </CustomTabItem>
                <CustomTabItem
                  v-if="value.hasUndoStatusHistory"
                  class="mt-2"
                  title="Historial de Cambio de Estatus"
                >
                  <span>
                    <i class="fa fa-info-circle mr-2 orange" />
                    <span class="title">
                      Historial de Cambio de Estatus
                    </span>
                  </span>
                  <HistoryStatusReturn :book="value" />
                </CustomTabItem>
              </CustomTab>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import store from "@/store/index";
import CustomCallout from "custom-callout";
import CustomBalloon from "custom-balloon";
import dropdown from "dropdown";
import { CustomTab, CustomTabItem } from "custom-tabs";
import {
  BookInfo,
  History,
  HistoryStatusReturn
} from "@/views/books/commons/tabs";
import { determineBook } from "@/modules/books-requests/api";
import DetermineBook from "./DetermineBook.vue";
import DetermineBookDate from "./DetermineBookDate.vue";
import StatusReturnReason from "./StatusReturnReason.vue";
import alert from "@/mixin/alert.mixin";
import {
  studentBookStatus,
  studentBookStatusString,
  getStudentBookStatusColor
} from "@/utils/constants/book/studentBookStatus";

export default {
  name: "SearchResultRow",
  mixins: [alert],
  components: {
    CustomCallout,
    CustomBalloon,
    dropdown,
    DetermineBook,
    DetermineBookDate,
    StatusReturnReason,
    CustomTab,
    CustomTabItem,
    BookInfo,
    History,
    HistoryStatusReturn
  },
  data() {
    return {
      getStudentBookStatusColor,
      isOpen: false,
      isDetermineBookVisible: false,
      isStatusReturnReasonVisible: false,
      targetStatusId: null
    };
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    collections: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    uniqueKey() {
      return `${this.value.bookId}-${this.value.academicYearId}-${this.value.studentSieId}`;
    },
    getBooksOptions() {
      return () => {
        const validStatus = [
          studentBookStatus.PedienteDeterminacionSAEE,
          studentBookStatus.PendienteCompra,
          studentBookStatus.PendienteEntregaCSEE,
          studentBookStatus.PendienteEntregaEscuela,
          studentBookStatus.PendienteEntregaEstudiante
        ];
        const items = [];

        if (validStatus.includes(this.value.statusId)) {
          items.push({
            label: "Determinar",
            icon: "fas fa-clipboard-check color-primary-1",
            click: () => this.onDetermineBook()
          });
        }

        if (this.value?.previousStatus) {
          items.push({
            label: "Regresar Estatus",
            icon: "fas fa-reply-all color-primary-1",
            click: () => this.showStatusReturnReason()
          });
        }

        return items;
      };
    },
    isPendingCSEEDetermination() {
      return (
        this.isDetermineBookVisible &&
        this.value.statusId != studentBookStatus.PendienteEntregaEstudiante
      );
    },
    isPendingStudentDeliveryDetermination() {
      return (
        this.isDetermineBookVisible &&
        this.value.statusId == studentBookStatus.PendienteEntregaEstudiante
      );
    }
  },
  methods: {
    getCollapse() {
      let link = this.$refs[`ei-collapse-${this.uniqueKey}`];
      const isOpen = link.getAttribute("aria-expanded") == "true";
      return { link, isOpen };
    },
    toggleAdditionalInfo() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);
      link.click();
      this.isOpen = !isOpen;
    },
    close() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);

      if (isOpen) {
        this.isOpen = false;
        link.click();
      }
    },
    open() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);

      if (!isOpen) {
        this.isOpen = true;
        link.click();
      }
    },
    onDetermineBook() {
      switch (this.value.statusId) {
        case studentBookStatus.PendienteCompra:
          this.targetStatusId = studentBookStatus.PendienteEntregaCSEE;
          this.determineBookCall(
            `¿Está seguro que desea poder cambiar el estatus de ${this.value.status} a ${studentBookStatusString.PendienteEntregaCSEE}?`
          );
          break;
        case studentBookStatus.PendienteEntregaCSEE:
          this.targetStatusId = studentBookStatus.PendienteEntregaEscuela;
          this.determineBookCall(
            `¿Está seguro que desea poder cambiar el estatus de ${this.value.status} a ${studentBookStatusString.PendienteEntregaEscuela}?`
          );
          break;
        case studentBookStatus.PendienteEntregaEscuela:
          this.targetStatusId = studentBookStatus.PendienteEntregaEstudiante;
          this.determineBookCall(
            `¿Está seguro que desea poder cambiar el estatus de ${this.value.status} a ${studentBookStatusString.PendienteEntregaEstudiante}?`
          );
          break;
        case studentBookStatus.PedienteDeterminacionCSEE:
        case studentBookStatus.PedienteDeterminacionSAEE:
        case studentBookStatus.PendienteEntregaEstudiante:
          this.showDetermineBook();
          break;
      }
    },
    showDetermineBook() {
      this.open();
      this.hideStatusReturnReason();
      this.isDetermineBookVisible = true;
    },
    showStatusReturnReason() {
      this.open();
      this.hideDetermineBook();
      this.isStatusReturnReasonVisible = true;
    },
    hideDetermineBook() {
      this.isDetermineBookVisible = false;
    },
    hideStatusReturnReason() {
      this.isStatusReturnReasonVisible = false;
    },
    refreshSearch() {
      this.$emit("refresh-search");
      this.hideDetermineBook();
      this.hideStatusReturnReason();
    },
    async determineBookCall(alertTitle) {
      const answer = await this.ShowCancelModal("Confirmación", alertTitle);

      const book = {
        bookId: this.value.bookId,
        academicYearId: this.value.academicYearId,
        studentSieId: this.value.studentSieId,
        TargetStatusId: this.targetStatusId
      };

      if (answer) {
        determineBook(book)
          .then(res => {
            if (res.status == 200) {
              this.ShowToast(
                "Proceso exitoso.",
                "Los datos fueron guardados exitosamente.",
                "success"
              );
              this.refreshSearch();
            }
          })
          .catch(err => {
            if (err && err.response && err.response.data) {
              this.ShowToast("Error", err.response.data.message, "error");
            } else {
              this.ShowToast("Error", err.message, "error");
            }
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";
.additional-container {
  background-color: #f7f7f7;
  border-radius: 5px;
}

::v-deep .ac-btn:not(:hover) {
  background: transparent !important;
}

.pl-c-xl {
  padding-left: 40px !important;
}

.orange {
  color: #ff7058;
}

::v-deep .custom-button > div > #dropdownMenuButton {
  color: black !important;
  font-weight: 700 !important;
}

.pl-q {
  padding-left: 3rem;
}

::v-deep button#dropdownMenuButton {
  background: transparent !important;
}

::v-deep .dropdown-menu.dropdown-menu-right {
  width: 100% !important;
}

.radio-button-container {
  height: 100%;
  align-items: unset !important;
}

.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
  background-color: #e2e2e2 !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.buttons-mobile {
  display: none;
}

@media only screen and (max-width: 375px) {
  ::v-deep .ac-btn {
    width: 100%;
  }

  .grey-divider::before {
    content: "";
    position: absolute;
    left: 49%;
    margin-left: -43%;
    width: 85%;
    height: 1px;
    background: #b5c3bc;
    margin-top: -10px;
  }

  .pl-c {
    margin-left: 15px;
  }
  .selct-text {
    display: none;
  }

  .fa-check {
    margin-right: 0px !important;
  }

  .buttons-mobile {
    display: flex;
  }

  .lg-btn {
    width: 100%;
  }

  .buttons-full {
    display: none;
  }

  ::v-deep .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal !important;
  }

  ::v-deep .info-text {
    color: #11291b !important;
    font-weight: normal !important;
    font-size: 12px !important;
  }

  ::v-deep .balloon-container {
    font-size: 12px !important;
  }

  .custom-radio-container > span:first-of-type {
    height: 100% !important;
    transform: none;
    top: 38px;
  }
}

::v-deep .info-text-title {
  color: #727272;
  font-size: 16px;
  font-weight: normal;
}

::v-deep .info-text {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

::v-deep .bg-gray {
  background-color: #e2e2e2 !important;
}

::v-deep .bg-green {
  background-color: #2db782 !important;
  border-color: #2db782;
}

::v-deep .radio .cr {
  border: 2px solid #ffffff !important;
}

::v-deep .step-label {
  color: #ffffff !important;
}

::v-deep .step-label-mobile {
  color: #ffffff !important;
}

::v-deep .balloon-container {
  font-size: 16px;
}

::v-deep .balloon-container.green-light {
  background-color: $green_light !important;
}
</style>
